import BugReportIcon from '@mui/icons-material/BugReport';
import IconButton from '@mui/material/IconButton';
import Tooltip from "@mui/material/Tooltip";
import ConstructionIcon from '@mui/icons-material/Construction';
import { useStoreDispatch } from '../../store/Hooks';
import { navSliceActions } from '../../store/slices/NavSlice';

const TestToolsButton = () => {
    const dispatch = useStoreDispatch();

    const handleOpenTestingTools = () => {
        dispatch(
            navSliceActions.openRightDrawer({
                type: "testing",
                resourceID: null,
            }),
        );
    }



    return (
        <Tooltip title="Open Testing Tools">
            <IconButton
                onClick={handleOpenTestingTools}
                style={{ fontSize: "20pt" }}
                aria-label="Open Testing Tools"
                color="inherit">
                <ConstructionIcon style={{ fontSize: "30pt" }} />
            </IconButton>
        </Tooltip>
    )

}

export default TestToolsButton